import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default function LegalMentions() {
  return (
    <div className="relative min-h-screen pt-20 text-black overflow-hidden bg-white">

      <section className="px-6 pt-10 pb-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-semibold leading-tight">Mentions Légales</h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 10/08/2025</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto space-y-10 text-[15px] leading-7 text-gray-800">

          <p>
            Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'économie
            numérique (LCEN), il est porté à la connaissance des utilisateurs et visiteurs du site{" "}
            <span className="font-medium">savoinimaux.com</span> (ci-après « le Site ») les présentes mentions légales.
          </p>
          <p>
            La connexion et la navigation sur le Site valent acceptation sans réserve des présentes mentions légales,
            accessibles en permanence via le lien en bas de page.
          </p>

          {/* 1. Éditeur */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">1. Éditeur du site</h2>
            <p>Le Site est édité par :</p>
            <ul className="mt-3 space-y-1 pl-0 list-none">
              <li><span className="font-medium">Dénomination sociale :</span> SAVOINIMAUX</li>
              <li><span className="font-medium">Forme juridique :</span> Association régie par la loi du 1er juillet 1901 et le décret du 16 août 1901</li>
              <li><span className="font-medium">Siège social :</span> 47 Rue du Pont Neuf, 74150 Rumilly</li>
              <li><span className="font-medium">Siret : </span> N° 794 267 302</li>
              <li><span className="font-medium">Numéro RNA/Préfecture  :</span> Annecy sous le n° W741003711</li>
              <li><span className="font-medium">Numéro de TVA intracommunautaire :</span> (non encore attribué / à compléter)</li>
              <li><span className="font-medium">Téléphone :</span> +33 (0)6 44 68 52 53</li>
              <li>
                <span className="font-medium">E-mail :</span>{" "}
                <a href="mailto:savoinimaux@gmail.com" className="underline">savoinimaux@gmail.com</a>
              </li>
              <li><span className="font-medium">Directeur de la publication :</span> Stephany Roux</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">2. Développement et réalisation technique du site</h2>
            <p>Le site a été conçu, développé et mis en ligne par :</p>
             <ul className="mt-3 space-y-1 pl-0 list-none">
              <li><span className="font-medium">Dénomination sociale :</span> NOXZI</li>
              <li><span className="font-medium">Forme juridique :</span> Société par actions simplifiée unipersonnelle (SASU)</li>
              <li><span className="font-medium">Capital social :</span> 100,00 €</li>
              <li><span className="font-medium">Siège social :</span> 792 Chemin de Charrière Neuve, 73000 Chambéry, France</li>
              <li><span className="font-medium">RCS :</span> Chambéry — SIREN 990 027 377</li>
              <li><span className="font-medium">Numéro de TVA intracommunautaire :</span> (non encore attribué / à compléter)</li>
              <li><span className="font-medium">Téléphone :</span> +33 (0)6 03 59 99 52</li>
              <li>
                <span className="font-medium">E-mail :</span>{" "}
                <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>
              </li>
              <li>
                <span className="font-medium">Site internet :</span>{" "}
                <a href="https://noxzi.fr" className="underline">noxzi.fr</a>
              </li>
              <li><span className="font-medium">Responsable Technique :</span> Lionel FAURE</li>
            </ul>
            <p> La relation entre l'association Savoinimaux et NoxZi SASU est régie par un contrat de prestation de
              services distinct. NoxZi SASU intervient en qualité de prestataire technique indépendant et n'est pas
              coéditeur du site.</p>
          </section>

          {/* 2. Hébergeur */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">3. Hébergeur</h2>
            <p>Conformément à l'article 6-I-2° de la LCEN, l'hébergeur du présent site est :</p>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><span className="font-medium">Raison sociale :</span> LWS – Ligne Web Services</li>
              <li><span className="font-medium">Siège social :</span> 4 rue Galvani, 75017 Paris, France</li>
              <li><span className="font-medium">Téléphone :</span> +33 1 77 62 30 03</li>
              <li>
                <span className="font-medium">Site :</span>{" "}
                <a href="https://www.lws.fr" target="_blank" rel="noreferrer" className="underline">
                  www.lws.fr
                </a>
              </li>
            </ul>
          </section>

          {/* 3. Accès au site */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">4. Accès au site</h2>
            <p>
              Le site est en principe accessible 24h/24 et 7j/7, sauf interruption, programmée ou non, pour des
              besoins de maintenance technique, de mise à jour, de force majeure ou de tout événement indépendant de
              la volonté de l'association.
            </p>
             <p>
              L'association Savoinimaux s'engage à mettre en œuvre tous les moyens raisonnablement nécessaires pour
              garantir la continuité du service et rétablir l'accès dans les meilleurs délais en cas
              d'indisponibilité. Toutefois, aucune garantie de disponibilité permanente ne peut être accordée.
              L'association ne saurait être tenue responsable des dommages, de quelque nature que ce soit, résultant
              d'une indisponibilité totale ou partielle du site.
            </p>
          </section>

          {/* 4. Propriété intellectuelle */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">5. Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments constituant le site — structure générale, textes, articles, photographies,
              illustrations, logos, icônes, charte graphique, logiciels, codes sources et tout autre contenu — est
              la propriété exclusive de l'association Savoinimaux ou de ses partenaires, et est protégé par les
              dispositions du Code de la propriété intellectuelle ainsi que par les conventions internationales
              applicables.
            </p>
            <p className="mt-3">
              Toute reproduction, représentation, modification, publication, adaptation, traduction ou exploitation
              de tout ou partie des éléments du site, par quelque procédé et sur quelque support que ce soit, sans
              l'autorisation préalable et écrite de l'association Savoinimaux, est strictement interdite et
              constituerait une contrefaçon au sens des articles L. 335-2 et suivants du Code de la propriété
              intellectuelle, susceptible d'engager la responsabilité civile et pénale de son auteur.
            </p>
            <p className="mt-3">
              La marque <span className="font-medium">Savoinimaux</span>, les logos
              et les signes distinctifs figurant sur le site sont des marques déposées ou en cours de dépôt. Toute
              utilisation sans autorisation préalable et écrite est strictement prohibée sous peine de poursuites.
            </p>
            <p>  
              Les photographies d'animaux publiées sur le site sont la propriété de leurs auteurs respectifs.
              Toute réutilisation est soumise à autorisation expresse.
              </p>
          </section>

          {/* 5. Responsabilité */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">6. Limitation de responsabilité</h2>
            <p>
              L'association Savoinimaux s'efforce de fournir sur le site des informations aussi précises, exactes et
              à jour que possible. Toutefois, elle ne saurait garantir l'exhaustivité, l'exactitude ou la
              complétude des informations publiées, et décline toute responsabilité pour les omissions,
              inexactitudes ou carences dans la mise à jour, qu'elles soient de son fait ou du fait de tiers
              partenaires fournissant ces informations.
            </p>
            <p className="mt-3">
              Les informations présentes sur le site sont fournies à titre purement informatif et associatif. Elles
              ne constituent en aucun cas des conseils juridiques, médicaux, vétérinaires ou professionnels. Pour
              toute question spécifique, l'utilisateur est invité à consulter un professionnel compétent.
            </p>
            <p className="mt-3">
              L'association ne pourra être tenue responsable des dommages directs ou indirects causés à
              l'équipement de l'utilisateur lors de l'accès au site, notamment liés à l'utilisation d'un matériel
              inadapté, à l'apparition d'un bug, d'un virus ou d'une incompatibilité logicielle.
            </p>
          </section>

          {/* 6. Liens hypertextes */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">7. Liens hypertextes</h2>
            <p>
               Le site peut contenir des liens hypertextes vers des sites internet tiers ou des ressources en ligne
              externes. L'association Savoinimaux n'exerce aucun contrôle sur ces sites et n'assume aucune
              responsabilité quant à leur contenu, leurs politiques de confidentialité, leurs publicités ou les
              produits et services qui y sont proposés.
            </p>
            <p className="mt-3">
               La mise en place d'un lien hypertexte pointant vers le présent site est autorisée, à condition
              qu'elle n'induise pas en erreur l'utilisateur quant à l'origine du contenu et qu'elle ne porte pas
              atteinte à l'image ou à la réputation de l'association Savoinimaux. Tout lien utilisant la technique
              du cadre framing est expressément interdit sans accord préalable écrit de l'associatio
            </p>
          </section>

          {/* 7. Cookies */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">8. Cookies</h2>
            <p>
                Lors de la navigation sur le site, des cookies peuvent être déposés sur le terminal de l'utilisateur.
              Un cookie est un petit fichier texte enregistré par le navigateur, permettant notamment d'analyser la
              navigation, de mémoriser des préférences ou de mesurer l'audience du site.
            </p>
            <p className="mt-3">
               Conformément à la loi n° 78-17 du 6 janvier 1978 modifiée (Loi Informatique et Libertés) et aux
              lignes directrices de la Commission Nationale de l'Informatique et des Libertés (CNIL), le dépôt de
              cookies non strictement nécessaires au fonctionnement du site est soumis au consentement préalable de
              l'utilisateur.
            </p>
            <p className="mt-3">
              L'utilisateur peut configurer son navigateur pour refuser ou supprimer les cookies à tout moment. Ce
              paramétrage est susceptible de modifier les conditions de navigation sur le site. Pour en savoir plus,
              consultez nos {" "}
              <Link to="/cgu" className="underline">Conditions Générales d'Utilisation</Link>.
            </p>
          </section>

          {/* 8. Données personnelles */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">9. Protection des données personnelles (RGPD)</h2>
            <p>
              L'association Savoinimaux, agissant en qualité de <span className="font-medium">responsable du traitement</span>{" "}
              au sens de l'article 4(7) du RGPD, traite des données à caractère personnel dans le strict respect du
              Règlement (UE) 2016/679 du 27 avril 2016 et de la loi Informatique et Libertés du 6 janvier 1978
              modifiée.
            </p>
            <p className="mt-3">Les données collectées via les formulaires du Site sont utilisées aux fins suivantes :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Traitement et suivi des demandes de contact, d'adoption et de signalement ;</li>
              <li>Gestion de la relation avec les bénévoles, donateurs et partenaires ;</li>
              <li>Envoi d'informations associatives et communications liées à l'objet social (avec consentement préalable); </li>
              <li>Respect des obligations légales et réglementaires applicables à l'association.</li>
            </ul>
            <p className="mt-3">
              La base légale des traitements est, selon les cas : le consentement de la personne concernée (art. 6§1
              a) du RGPD), l'exécution d'un contrat ou de mesures précontractuelles (art. 6§1 b)), ou l'intérêt
              légitime de l'association (art. 6§1 f)).
            </p>
            <p> Les données personnelles collectées sont conservées pour la durée strictement nécessaire à la
              réalisation des finalités décrites ci-dessus, et au maximum pendant trois (3) ans à compter du dernier
              contact, sauf obligation légale de conservation plus longue.</p>
            <p> Conformément à la réglementation en vigueur, vous disposez des droits suivants sur vos données :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Droit d'accès (art. 15 RGPD) ;</li>
              <li>Droit de rectification (art. 16 RGPD) ;</li>
              <li>Droit à l'effacement (art. 17 RGPD) ;</li>
              <li>Droit à la limitation du traitement (art. 18 RGPD) ;</li>
              <li>Droit à la portabilité (art. 20 RGPD) ;</li>
              <li>Droit d'opposition (art. 21 RGPD).</li>
            </ul>
            <p className="mt-3">
               Pour exercer ces droits ou pour toute question relative au traitement de vos données personnelles,
              vous pouvez adresser votre demande à l'association par courriel à :{" "}
              <a href="mailto:savoinimaux@gmail.com" className="underline">savoinimaux@gmail.com</a>, ou par courrier postal à l'adresse
              du siège social, en joignant une copie d'un justificatif d'identité.
            </p>
            <p className="mt-3">
              En cas de réponse insatisfaisante, vous disposez du droit d'introduire une réclamation auprès de la
              Commission Nationale de l'Informatique et des Libertés (CNIL) — 3 Place de Fontenoy, 75007 Paris —{" "}
              <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="underline">www.cnil.fr</a>.
            </p>
            <p className="mt-3">
             Pour en savoir plus sur la manière dont l'association collecte et utilise vos données, consultez notre{" "}
              <Link to="/politique-de-confidentialite" className="underline">Politique de confidentialité</Link>.
            </p>
          </section>

          {/* 9. Droit applicable */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">10. Droit applicable et juridiction compétente</h2>
            <p>
              Les présentes mentions légales sont régies exclusivement par le droit français. En cas de litige
              relatif à l'interprétation, la validité ou l'exécution des présentes, et après toute tentative de
              résolution amiable préalable, les tribunaux français seront seuls compétents.
            </p>
            <p>
              Pour les litiges de consommation n'ayant pu être résolus amiablement, l'utilisateur peut recourir à
              la médiation de la consommation conformément aux articles L. 611-1 et suivants du Code de la
              consommation, ou à tout autre mode alternatif de règlement des différends (MARD).
            </p>
          </section>

          {/* 10. Mise à jour */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">11. Mise à jour des mentions légales</h2>
            <p>
              L'association Savoinimaux se réserve le droit de modifier les présentes mentions légales à tout
              moment, notamment afin de se conformer à toute évolution légale, réglementaire, jurisprudentielle ou
              technique. Les modifications entrent en vigueur dès leur mise en ligne.
            </p>
            <p>
              L'utilisateur est invité à consulter régulièrement les présentes mentions légales accessibles en bas
              de chaque page du site. La poursuite de la navigation après modification vaut acceptation des nouvelles
              mentions légales.
            </p>
          </section>

        </div>
      </section>
    </div>
  );
}